import { render, staticRenderFns } from "./checkback-m.vue?vue&type=template&id=6b6d8f8e"
import script from "./checkback-m.vue?vue&type=script&lang=js"
export * from "./checkback-m.vue?vue&type=script&lang=js"
import style0 from "./checkback-m.vue?vue&type=style&index=0&id=6b6d8f8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports